export default __webpack_public_path__ + "static/media/GoogleFit_Logo_Horizontal.6b7881ab.png";